var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "j-select-biz-component",
          _vm._g(
            _vm._b(
              {
                attrs: {
                  value: _vm.value,
                  option: _vm.option,
                  name: this.$store.getters.language["role"],
                  "need-init-all": true,
                  displayKey: "roleName",
                  disabled: _vm.disabled,
                  returnKeys: _vm.returnKeys,
                  listUrl: _vm.url.list,
                  columns: _vm.columns,
                  objectId: _vm.objectId,
                  isFix: _vm.isFix,
                  queryParamCode: "roleCode",
                  queryParamText: this.$store.getters.language[
                    "platform.roleUser.columns.roleCode"
                  ]
                }
              },
              "j-select-biz-component",
              _vm.$attrs,
              false
            ),
            _vm.$listeners
          )
        )
      ],
      1
    ),
    _c(
      "div",
      [
        _c("a-modal", {
          attrs: { title: "Title", visible: _vm.visible, zIndex: 1005 }
        })
      ],
      1
    ),
    _c("div", {
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function(text, record) {
            return _c("span", {}, [
              _c("a", [_vm._v(_vm._s(_vm.language["common.edit"]))])
            ])
          }
        }
      ])
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }